import { INTENT_MODULE_RESOURCE_TYPE } from "shared/IntentProject/constants";
import { IntentResource } from "types/generated";

export const isModuleResourcesGroup = (resourceType: IntentResource["resourceType"]) =>
  resourceType === INTENT_MODULE_RESOURCE_TYPE;
